// React import
import * as React from 'react'
import Box from 'src/components/Box';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import Title from 'src/components/Title';
import { Columns, Column } from 'src/components/Layout/Grid';
import FlexContainer from 'src/components/Layout/FlexContainer';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon';
import {format} from 'date-fns'
import Tooltip from 'src/components/Tooltip';
// Standard layout imports

interface IProps{
    favs: IActivityModel[];
    removeFormFavorite: (detailKursusId: number) => void
    setSelectedActivity: (detailKursusId: number) => void
}

class MyPageUserFavorites extends React.Component<IProps>{
    /**
     *
     */
    constructor(props: any) {
        super(props);

        this.removeFav = this.removeFav.bind(this);
    }
    public removeFav(fav: IActivityModel){
        this.props.removeFormFavorite(fav.detailKursusId)
    }

    public render() {
        // if none present in fav array show some msg about how to
        return ( <div>
            <Title className="mb2">MINE favoritter</Title>
        { this.props.favs.length > 0 ? <div>
            <Tooltip />
            <Box className="mb1">
            Her er en liste over de kurser, du har markeret som favoritter. Du kan klikke på stjernen for at fjerne dem fra listen.
            </Box>
                <div>
                    {
                        this.props.favs.map(f =>
                            <Box  key={f.detailKursusId}>
                            <Columns>
                            <Column md={"fill"}>
                            <div onClick={() => this.props.setSelectedActivity(f.detailKursusId)} style={{cursor: "pointer"}}>
                                {f.courseTitle}
                                </div>
                            </Column>
                            <Column md={"auto"}>
                            <FlexContainer>
                                <div className="mr2">{format(new Date(f.startDate), "dd.MM.yyyy")}</div>
                                <div data-tip="Fjern fra favoritliste">
                                <Button className="mr1" color="light" size="small" onClick={() => this.removeFav(f) }>
                                    <Icon name="star" color={"#FAC917"} />
                                </Button>
                                </div>
                            </FlexContainer>
                            </Column>
                                </Columns>
                                </Box>
                            )
                    }

                </div>
            </div>
        :
        <Box>Hvis du markerer et kursus som favorit, vises det her, og vil  forsvinde igen, når startdatoen passeres.</Box>
        }
        </div>
        )
    }
}

export default MyPageUserFavorites



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/myPageUserFavorites.component.tsx